module.exports = __webpack_public_path__ + "/img/DFN-4-Labeled-4RxZBG.svg";